import { useState } from 'react';
import Image from 'next/image';
import BlackBox from 'react-scale/components/elements/black-box';
import { Button } from 'react-scale/components';
import cn from 'classnames';

const MatchingExample = () => {
  const [state, setState] = useState<'idle' | 'loading' | 'completed'>('idle');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 relative">
      <div className="sm:rounded-xl bg-codGray flex flex-col space-y-4 items-start p-7 xl:p-7 w-screen sm:w-auto relative left-1/2 -translate-x-1/2">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 w-full items-center">
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/green-shirt.jpg"
              alt="A green shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/pink-shirt.jpg"
              alt="A pink shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/white-tshirt.jpg"
              alt="A white t-shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/red-shirt.jpg"
              alt="A person wearing red shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/black-tshirt.jpg"
              alt="A black t-shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox padding="sm">
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/purple-shirt.jpg"
              alt="A person wearing a purple shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
        </div>

        <div
          className={cn(
            'transition-opacity duration-150 ml-auto',
            state === 'completed' ? 'opacity-0 pointer-events-none' : 'opacity-100'
          )}
        >
          {/* @ts-ignore: Unreachable code error */}
          <Button
            disabled={state !== 'idle'}
            text={state === 'idle' ? 'DEDUPE' : 'DEDUPING...'}
            onClick={() => {
              setState('loading');
              setTimeout(() => setState('completed'), 1000);
            }}
          />
        </div>
      </div>

      <div className="sm:rounded-xl bg-codGray flex flex-col items-start py-9 px-11 sm:p-7 w-screen sm:w-auto relative left-1/2 -translate-x-1/2">
        <b
          className={cn(
            'transition-all duration-700 text-xs mb-4 inline-block',
            state === 'completed'
              ? 'opacity-100 visible'
              : 'invisible opacity-0 translate-y-4 scale-95'
          )}
        >
          Product Match
        </b>
        <div className="grid grid-cols-2 w-full gap-3">
          <BlackBox
            padding="md"
            className={cn(
              'transition-all duration-700 delay-75',
              state === 'completed'
                ? 'opacity-100 visible'
                : 'invisible opacity-0 translate-y-4 scale-95'
            )}
          >
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/white-tshirt.jpg"
              alt="A white t-shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
          <BlackBox
            padding="md"
            className={cn(
              'transition-all duration-700 delay-150',
              state === 'completed'
                ? 'opacity-100 visible'
                : 'invisible opacity-0 translate-y-4 scale-95'
            )}
          >
            <Image
              quality={100}
              className="rounded"
              src="/static/images/example/black-tshirt.jpg"
              alt="A black t-shirt"
              layout="responsive"
              width={116}
              height={116}
            />
          </BlackBox>
        </div>
      </div>
    </div>
  );
};

export default MatchingExample;
